export enum ETelemetryActionsAndLabels {
    Create = 'create',
    Click = 'click',
    View = 'view',
    Edit = 'edit',
}
export enum ETelemetryNames {
    ProductManagement = 'ProductManagement',
}
